import { Icon, Tooltip } from '@gcl/react-core';
import { ETransmittalStatus, ETransmittalType } from '@transmittal/transmittal.constants';
import * as React from 'react';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import { TransmittalDetailExportModalBtn, ITransmittalDetailExportModalBtnProps } from './TransmittalDetailExportModal';

export interface ITransmittalDetailTabDetailTopBarProps extends ITransmittalDetailExportModalBtnProps {
  masterScheduleId: number;
  transmittalId?: number;
  transmittalStatus?: ETransmittalStatus;
  transmittalType?: ETransmittalType;
  renderExportExcelButton: (excelIconElement: React.ReactElement) => React.ReactElement;
  renderExportPdfButton: (pdfIconElement: React.ReactElement) => React.ReactElement;
  onSearch: (searchText: string | undefined) => void;
  onClickShowHideRemovedItems: (show: boolean) => void;
  shouldShowRemovedItems?: boolean;
  isAnyActionLoading?: boolean;
  isPageDirty?: boolean;
  isReadOnly?: boolean;
}
export const TransmittalDetailTabDetailTopBar: React.FC<ITransmittalDetailTabDetailTopBarProps> = ({
  masterScheduleId,
  transmittalId,
  transmittalType,
  transmittalStatus,
  renderExportExcelButton,
  renderExportPdfButton,
  onSearch,
  onClickShowHideRemovedItems,
  shouldShowRemovedItems = false,
  isAnyActionLoading,
  isPageDirty = false,
  isReadOnly,
}) => {
  const { navigate } = useNavigate();
  return (
    <div className="gcl-gems-transmittal-detail-tab-detail-top-bar">
      <div className="gcl-gems-transmittal-detail-tab-detail-top-bar-left-content">
        {renderExportExcelButton(
          <Icon disabled={isAnyActionLoading} className="gcl-ic-btn-md" iconName="FiletypeXlsx" size={22} />,
        )}
        {renderExportPdfButton(
          <Icon
            disabled={isAnyActionLoading}
            iconName="Printer"
            size={22}
            className="gcl-ic-btn-md gcl-transmittal-detail-tab-detail-top-bar-print-btn"
          />,
        )}
        {
          // transmittalStatus === ETransmittalStatus.APPROVED && (
          <TransmittalDetailExportModalBtn
            disabled={isAnyActionLoading}
            masterScheduleId={masterScheduleId}
            transmittalId={transmittalId}
            transmittalType={transmittalType}
          />
        }
        {transmittalStatus !== ETransmittalStatus.APPROVED &&
          transmittalType !== ETransmittalType.ICE &&
          transmittalType !== ETransmittalType.REVIEWER &&
          !isReadOnly && (
            <div
              className="gcl-gems-transmittal-detail-tab-detail-top-bar-bulk-upload"
              onClick={() => {
                const params = {
                  id: transmittalId,
                };
                if (transmittalType === ETransmittalType.DESIGNER) {
                  navigate(routes.transmittals.designerTransmittal.bulkUpload.path, params);
                } else if (transmittalType === ETransmittalType.SITE) {
                  navigate(routes.transmittals.siteTransmittal.bulkUpload.path, params);
                } else if (transmittalType === ETransmittalType.ICE) {
                  navigate(routes.transmittals.checkerTransmittal.bulkUpload.path, params);
                } else if (transmittalType === ETransmittalType.REVIEWER) {
                  navigate(routes.transmittals.lirTransmittal.bulkUpload.path, params);
                }
              }}
            >
              Bulk Upload
            </div>
          )}
      </div>
      <div className="gcl-gems-transmittal-detail-tab-detail-top-bar-right-content">
        {/* <Input
          prefixLabel={{
            prefixIconName: 'Search',
          }}
          value={searchText}
          onChange={(newValue: string | number | undefined) => {
            const newValueStr = newValue ? newValue.toString() : undefined;
            setSearchText(newValueStr);
            onSearch(newValueStr);
          }}
        /> */}
        {shouldShowRemovedItems ? (
          <Tooltip overlay="Hide Remove From Use" id="Hide Remove From Use">
            <Icon
              iconName="EyeSlash"
              size={22}
              disabled={isPageDirty || isAnyActionLoading}
              onClick={() => {
                onClickShowHideRemovedItems(false);
              }}
              className="gcl-ic-btn-md"
            />
          </Tooltip>
        ) : (
          <Tooltip overlay="Show Remove From Use" id="Show Remove From Use">
            <Icon
              iconName="Eye"
              size={22}
              onClick={() => {
                onClickShowHideRemovedItems(true);
              }}
              className="gcl-ic-btn-md"
              disabled={isPageDirty || isAnyActionLoading}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};
